module.exports = __webpack_public_path__ + "static/img/subpages.cbdc2dda.jpg";